import { State } from './types'
import { Module } from 'vuex'
import { INITIAL_STATE } from './init'

export default async (): Promise<Module<State, {}>> => {
  return {
    namespaced: true,
    state: INITIAL_STATE()
  }
}
